import React, { useCallback, useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import Radio from '@material-ui/core/Radio';
import { ICustomer } from 'shared-types/SharedTypes';
import style from './style.module.css';
import TagIcon from 'external-components/tag-icon';
import { ICustomerSearchResultTab } from './types';
import classNames from 'classnames';

const NS = 'CustomerSearchResultTab';

export default function CustomerSearchResultTab(props: ICustomerSearchResultTab) {
  const customer = props.customer || ({} as ICustomer);
  const fullName = customer?.firstName
    ? `${customer.firstName} ${customer.lastName || ''}`
    : customer?.lastName || '';
  const handleSelectCustomer = useCallback(
    (event) => {
      event.stopPropagation();
      props.handleViewCustomer(customer);
    },
    [props.handleViewCustomer, customer]
  );
  const handleEditCustomer = useCallback(
    (event) => {
      event.stopPropagation();
      props.handleEditCustomer(customer);
    },
    [props.handleEditCustomer, customer]
  );
  /**
   * @todo: might have to wrap this in TableRow and TableCell, because divs aren't technically
   * allowed to nest inside tbody directly
   */
  return (
    <div
      className={classNames({
        [style.flexRow]: true,
        [style.rootContainer]: true,
      })}
      onClick={handleSelectCustomer}
    >
      <div
        onClick={handleEditCustomer}
        className={classNames({
          [style.iconWrap]: true,
        })}
      >
        <EditIcon className={style.icon} />
      </div>
      <div
        className={classNames({
          [style.flexColumn]: true,
          [style.nameSpace]: true,
        })}
      >
        <div className={style.hideTextOverflow}>{fullName}</div>
        <div>{customer.phone}</div>
      </div>
      <div
        className={classNames({
          [style.flexColumn]: true,
          [style.contentSpace]: true,
        })}
      >
        <div className={style.hideTextOverflow}>
          {customer.tags.map((tag, i) => {
            if (i < 8) {
              return (
                <span className={style.tagIconStyle} key={i}>
                  {' '}
                  <TagIcon {...tag} key={i + 1} />{' '}
                </span>
              );
            }
            return null;
          })}
        </div>
        <span className={style.hideTextOverflow}>{customer.email}</span>
      </div>
      <div
        className={classNames({
          [style.flexColumn]: true,
          [style.nameSpace]: true,
        })}
      >
        <div className={style.hideTextOverflow}>{customer.company}</div>
      </div>
      <div onClick={handleSelectCustomer} className={style.iconWrap}>
        <Radio size="small" checked={props.selectedId === customer._id} />
      </div>
    </div>
  );
}
